import script from "./admin_comCode.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_comCode.vue?vue&type=script&setup=true&lang=js"

import "./admin_comCode.vue?vue&type=style&index=0&id=455c9f6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-455c9f6b"]])

export default __exports__